import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Auth from './routes/auth';
import './static/css/style.css';

import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';

const { theme } = config;

const ProviderConfig = () => {
  const { rtl, user, topMenu, darkMode } = useSelector(state => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      user: state.auth.user,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath]);

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Router basename={process.env.PUBLIC_URL}>
          {user && !Object.keys(user).length > 0 ? <Route path="/" component={Auth} /> : <ProtectedRoute />}
          {Object.keys(user).length > 0 &&
            (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
              <>
                {user?.role?.name === 'admin' ? (
                  <Redirect to="/admin" />
                ) : user?.role?.name === 'writer' ? (
                  <Redirect to="/writer" />
                ) : (
                  <Redirect to="/" />
                )}
              </>
            )}
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
};

function App() {
  return <ProviderConfig />;
}

export default hot(App);
